import QuickReplyList from './QuickReplyList'

export default QuickReplyList
